<template>
  <button class="btn" :type="type" :style="{ background: bgColor }">{{ title }}</button>
</template>

<script>
export default {
  name: 'primary-button',
  props: {
    title: {
      type: String,
      default: '',
    },
    bgColor: {
      default: null,
    },
    className: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
    },
  },
}
</script>

<style scoped>
* {
  padding: 0;
}
button {
  color: white;
  border-radius: 8px;
  height: 38px;
  width: 100%;
  font-family: IRANSans;
}
</style>
